import Api from './api';

const BASE = '/task-templates';

export const paginate = async (page = 1, size = 500, field = '', search = '') => {
  try {
    const result = await Api.get(`${BASE}/paginate`, { params: { page, size, field, search } });
    if (result.data?.success) return { success: true, data: result.data.data, count: result.data.count };
    return { success: false, data: [] };
  } catch {
    return { success: false, data: [] };
  }
};

export const getById = async (id) => {
  try {
    const result = await Api.get(`${BASE}/${id}`);
    if (result.data?.success) return { success: true, data: result.data.data };
    return { success: false, data: null };
  } catch {
    return { success: false, data: null };
  }
};

export const add = async (data) => {
  try {
    const result = await Api.post(BASE, data);
    if (result.data?.success) return { success: true, data: result.data.data };
    return { success: false };
  } catch {
    return { success: false };
  }
};

export const update = async (id, data) => {
  try {
    const result = await Api.put(`${BASE}/${id}`, data);
    if (result.data?.success) return { success: true, data: result.data.data };
    return { success: false };
  } catch {
    return { success: false };
  }
};

export const deleteById = async (id) => {
  try {
    const result = await Api.delete(`${BASE}/${id}`);
    if (result.data?.success) return { success: true };
    return { success: false };
  } catch {
    return { success: false };
  }
};

export const getOrganizations = async () => {
  try {
    const result = await Api.get('/organizations/tech');
    if (result.data?.success) {
      return {
        success: true,
        data: (result.data.data || [])
          .filter(o => o.active)
          .sort((a, b) => a.name.localeCompare(b.name)),
      };
    }
    return { success: false, data: [] };
  } catch {
    return { success: false, data: [] };
  }
};

export const addOrganizations = async (templateId, ids) => {
  try {
    const result = await Api.post(`${BASE}/${templateId}/organizations`, { ids });
    return result.data?.success ? { success: true } : { success: false };
  } catch {
    return { success: false };
  }
};

export const removeOrganizations = async (templateId, ids) => {
  try {
    const result = await Api.delete(`${BASE}/${templateId}/organizations`, { data: { ids } });
    return result.data?.success ? { success: true } : { success: false };
  } catch {
    return { success: false };
  }
};

export const addCategories = async (templateId, ids) => {
  try {
    const result = await Api.post(`${BASE}/${templateId}/categories`, { ids });
    return result.data?.success ? { success: true } : { success: false };
  } catch {
    return { success: false };
  }
};

export const removeCategories = async (templateId, ids) => {
  try {
    const result = await Api.delete(`${BASE}/${templateId}/categories`, { data: { ids } });
    return result.data?.success ? { success: true } : { success: false };
  } catch {
    return { success: false };
  }
};

export const addTask = async (templateId, task) => {
  try {
    const result = await Api.post(`${BASE}/${templateId}/tasks`, task);
    if (result.data?.success) return { success: true, data: result.data.data };
    return { success: false };
  } catch {
    return { success: false };
  }
};

export const removeTasks = async (templateId, ids) => {
  try {
    const result = await Api.delete(`${BASE}/${templateId}/tasks`, { data: { ids } });
    return result.data?.success ? { success: true } : { success: false };
  } catch {
    return { success: false };
  }
};

const normalizeCategory = (cat) => {
  const lc = Object.fromEntries(Object.entries(cat).map(([k, v]) => [k.toLowerCase(), v]));
  return { ...lc, organizationId: lc.organizationid };
};

export const getCategoriesByOrganizations = async (orgIds) => {
  if (!orgIds || orgIds.length === 0) return { success: true, data: [] };
  try {
    const result = await Api.get('/organizationcategories/organizations/dapper', {
      params: { orgIds: orgIds.join(',') },
    });
    if (result.data?.success) return { success: true, data: (result.data.data || []).map(normalizeCategory) };
    return { success: false, data: [] };
  } catch {
    return { success: false, data: [] };
  }
};
